/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
// import "react-table/react-table.css";

import CSVExportModal from './CSVExportModal'
import profile_avatar from '../../assets/images/mock/StockProfilePic.png'

const ReactTableFixedColumns = createTable(ReactTable)

const buildHeaders = (t) => [
  { label: t('common.field.lastName'), key: 'lastname' },
  { label: t('common.field.firstName'), key: 'firstname' },
  { label: t('reports.common.level'), key: 'rank' },
  { label: t('reports.curriculumReportTable.levelProgress'), key: 'rankprogress' },
  { label: t('reports.curriculumReportTable.posture'), key: 'posture' },
  { label: t('reports.curriculumReportTable.power'), key: 'power' },
  { label: t('reports.curriculumReportTable.grip'), key: 'grip' },
  { label: t('reports.curriculumReportTable.ballFlight'), key: 'ballflight' },
  { label: t('reports.curriculumReportTable.alignment'), key: 'alignment' },
  { label: t('common.golf.putting'), key: 'putting' },
  { label: t('reports.curriculumReportTable.greenReading'), key: 'greenreading' },
  { label: t('reports.curriculumReportTable.workEthic'), key: 'workethic' },
  { label: t('reports.curriculumReportTable.mastery'), key: 'mastery' },
  { label: t('reports.curriculumReportTable.honor'), key: 'honor' },
  { label: t('reports.curriculumReportTable.fitness'), key: 'fitness' },
  { label: t('reports.curriculumReportTable.performance'), key: 'performance' },
]

class CurriculumReportTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      dataLoader: false,
      data: [],
    }
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  createData = () => {
    const { data } = this.props
    const tempData = []
    this.setState({ dataLoader: true })
    if (data.length > 0) {
      data.map((info) => {
        const lastname = info.student.last_name
        const firstname = info.student.first_name
        const rank = info.current_rank.name
        const rankprogress = info.percent_rank_complete.toFixed(1) + '%'
        const posture = info.report[8].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const power = info.report[9].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const grip = info.report[4].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const ballflight = info.report[1].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const alignment = info.report[0].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const putting = info.report[10].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const greenreading = info.report[3].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const workethic = info.report[11].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const mastery = info.report[6].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const honor = info.report[5].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const fitness = info.report[2].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'
        const performance = info.report[7].has_completed_objective
          ? String.fromCharCode(0x2713)
          : '---'

        tempData.push({
          lastname,
          firstname,
          rank,
          rankprogress,
          posture,
          power,
          grip,
          ballflight,
          alignment,
          putting,
          greenreading,
          workethic,
          mastery,
          honor,
          fitness,
          performance,
        })
      })
    }

    this.setState({
      showModal: !this.state.showModal,
      data: tempData,
    })
  }

  renderUserAvatarCell = (props) => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      key={props.value ? props.value.id : null}
      onClick={() =>
        this.props.toProfile(props.value ? props.value.id : null)
      }
    >
      <div className='small-round-image-wrapper'>
        {props.value ? (
          <img
            className='round-image'
            src={
              props.value.avatar
                ? props.value.avatar.file_url
                : profile_avatar
            }
            alt={
              props.value
                ? `${props.value.first_name} ${props.value.last_name}`
                : ''
            }
          />
        ) : null}
      </div>
    </div>
  )
  renderTableCellName = (props) => (
    <div
      className='number'
      style={{
        backgroundColor: '#2b3843',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: props.value ? props.value.color_hex : 'white' }}>
        {props.value ? props.value.name : '---'}
      </div>
    </div>
  )
  renderRankProgress = (props) => (
    <div
      className='number'
      style={{
        backgroundColor: '#2b3843',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: 'white' }}>
        {props.value ? `${Math.round(props.value)}%` : '---'}
      </div>
    </div>
  )
  // renderCurriculumProgress = props => {
  //   let currentRank = props.value.current_rank
  //     ? props.value.current_rank.id
  //     : null;
  //   let op36RankCount = 6;
  //   let op36SubjectCount = 12;

  //   if (currentRank) {
  //     let rankFraction = currentRank / op36RankCount;
  //     let rankMatchArray = [];

  //     props.value.report.map(report => {
  //       if (report.rank) {
  //         if (report.rank.id === currentRank) {
  //           rankMatchArray.push(report.rank.id);
  //         }
  //       }
  //     });

  //     let subjectFraction = rankMatchArray.length / op36SubjectCount;

  //     return (
  //       <div
  //         className="number"
  //         style={{
  //           backgroundColor: "#2b3843",
  //           width: "100%",
  //           height: "100%",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center"
  //         }}
  //       >
  //         <div style={{ color: "white" }}>
  //           {`${Math.round((rankFraction + subjectFraction) * 100) - 17}%`}
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div
  //         className="number"
  //         style={{
  //           backgroundColor: "#2b3843",
  //           width: "100%",
  //           height: "100%",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center"
  //         }}
  //       >
  //         <div style={{ color: "white" }}>---</div>
  //       </div>
  //     );
  //   }
  // };
  renderTableCell = (props) => (
    <div
      className='number'
      style={{
        backgroundColor: props.value ? props.row.current_rank.color_hex : '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          color: props.value ? 'white' : '',
        }}
      >
        {props.value ? String.fromCharCode(0x2713) : '---'}
      </div>
    </div>
  )
  handleRankSort = (a, b, _desc) => {
    a = a === null || a === undefined ? '' : a.id
    b = b === null || b === undefined ? '' : b.id

    if (a > b) {
      return 1
    }
    if (a < b) {
      return -1
    }
    return 0
  }
  handleRankProgressSort = (a, b, _desc) => {
    a = a === null || a === undefined ? '' : a
    b = b === null || b === undefined ? '' : b

    // a = typeof a === 'string' ? a.toLowerCase() : a
    // b = typeof b === 'string' ? b.toLowerCase() : b

    if (a > b) {
      return 1
    }
    if (a < b) {
      return -1
    }
    return 0
  }
  renderTable = () => {
    const { loader, data, t } = this.props
    const columns = [
      {
        Header: '',
        accessor: 'student',
        Cell: (props) => this.renderUserAvatarCell(props),
        sortable: false,
        fixed: true,
      },
      {
        Header: t('common.field.firstName'),
        accessor: 'student.first_name',
        fixed: true,
      },
      {
        Header: t('common.field.lastName'),
        accessor: 'student.last_name',
        fixed: true,
      },
      // {
      //   Header: "Curriculum Progress",
      //   accessor: "",
      //   Cell: props => this.renderCurriculumProgress(props),
      //   style: { padding: 0 },
      //   sortable: false
      // },
      {
        Header: t('reports.common.level'),
        accessor: 'current_rank',
        Cell: (props) => this.renderTableCellName(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.levelProgress'),
        accessor: 'percent_rank_complete',
        Cell: (props) => this.renderRankProgress(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankProgressSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.posture'),
        accessor: 'report[8].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.power'),
        accessor: 'report[9].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.grip'),
        accessor: 'report[4].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.ballFlight'),
        accessor: 'report[1].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.alignment'),
        accessor: 'report[0].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('common.golf.putting'),
        accessor: 'report[10].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.greenReading'),
        accessor: 'report[3].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.workEthic'),
        accessor: 'report[11].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.mastery'),
        accessor: 'report[6].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.honor'),
        accessor: 'report[5].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.fitness'),
        accessor: 'report[2].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
      {
        Header: t('reports.curriculumReportTable.performance'),
        accessor: 'report[7].has_completed_objective',
        Cell: (props) => this.renderTableCell(props),
        style: { padding: 0 },
        sortMethod: (a, b, desc) => this.handleRankSort(a, b, desc),
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-4'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4 d-flex align-items-center'>
            <button
              className='btn btn-primary mr-2 refresh-button'
              onClick={this.props.resetProgramSearch}
            >
              <i className='fa fa-undo' aria-hidden='true' />
            </button>
            <select
              onChange={this.props.handleProgramSelected}
              value={this.props.programSelected}
              name='program'
              className='form-control'
              disabled={this.props.programLoader || this.props.loader}
            >
              <option value={-1} disabled>
                {this.props.programLoader
                  ? t('reports.common.loadingClasses')
                  : t('reports.curriculumReportTable.filterByClassOptional')}
              </option>
              {this.props.renderPrograms()}
            </select>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={!loader ? data : []}
              columns={columns}
              defaultPageSize={10}
              loading={this.props.loader}
              previousText={t('reports.common.pagination.previous')}
              nextText={t('reports.common.pagination.next')}
              pageText={t('reports.common.pagination.page')}
              ofText={t('reports.common.pagination.of')}
              rowsText={t('reports.common.pagination.rows')}
              loadingText={t('reports.common.loadingReport')}
              noDataText={this.props.loader ? '' : t('reports.common.noDataFound')}
            />
          </div>
        </div>
        {this.props.loader ? (
          ''
        ) : (
          <div>
            <button
              className='btn btn-primary mr-3 mt-3'
              onClick={this.props.showCurriculumModal}
            >
              <i className='fa fa-print text-white mr-1' aria-hidden='true' />{' '}
              {t('reports.common.printOverview')}
            </button>
            <button onClick={this.createData} className='mt-3 btn btn-success'>
              {t('reports.common.exportAsCsv')}
            </button>
          </div>
        )}
      </div>
    )
  }

  render() {
    const { t } = this.props
    return (
      <div>
        {this.renderTable()}
        <CSVExportModal
          headers={buildHeaders(t)}
          data={this.state.data}
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          reportType={t('reports.curriculumReportTable.golferCurriculumSummary')}
          filename={'curriculum-summary.csv'}
        />
      </div>
    )
  }
}

CurriculumReportTable.propTypes = {
  programLoader: PropTypes.bool,
  loader: PropTypes.bool,
}

export default withTranslation()(CurriculumReportTable)
